import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Ref, ref } from 'vue';
import { RouteLocationNormalizedLoaded, Router, useRoute, useRouter } from 'vue-router';
import { ComponentException } from '@/exceptions/component-exception';
import ItemDetailsModal from '@/components/ItemDetails/ItemDetailsModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDetailsView',
  setup(__props) {

const router: Router = useRouter();
const route: RouteLocationNormalizedLoaded = useRoute();

if (!route.params.id || !route.params.enhancement) {
  throw new ComponentException('Required route parameters id or enhancement are empty');
}

const id: Ref<number> = ref(Number(route.params.id));
const enhancement: Ref<number> = ref(Number(route.params.enhancement));

const redirectToItemView = () => {
  /**
   * TODO: Figure out what is the desired routing history logic when closing modal
   */
  router.push({
    name: 'item',
    params: {
      id: route.params.id,
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ItemDetailsModal, {
    id: id.value,
    enhancement: enhancement.value,
    onClose: redirectToItemView
  }, null, 8, ["id", "enhancement"]))
}
}

})